function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var activeStep = 'js-step-active';
var layerVisible = 'layer--visible';
var activeWorkshop = 'o-main--workshop';
var activeSidebar = 'o-slider__sidebar--visible';
var activeHeader = 'o-slider__header--visible';

/**
 * @param {IntersectionObserverEntry[]} entries
 */
function $observerCallback(entries) {
  var _this = this;
  entries.forEach(function (entry) {
    var isIntersecting = entry.isIntersecting,
      target = entry.target;
    if (_this.isOpen() && isIntersecting) {
      var id = parseInt(target.dataset.step, 10);

      // window.location.hash = target.id;
      _this.pagination.textContent = id;
      target.classList.add(activeStep);
      var element = document.querySelector(".".concat(activeStep, ":not(#").concat(target.id, ")"));
      if (element) {
        element.classList.remove(activeStep);
      }
      _this.prevStepButton.disabled = id === 1;
      _this.nextStepButton.disabled = id === _this.stepList.length;
    }
  });
}

/**
 * @param {HTMLElement} button
 */
function $pagination(button) {
  var position = this.stepList.findIndex(function (step) {
    return step.classList.contains(activeStep);
  });
  var _filter = [{
      "class": 'js-button-prev',
      index: position - 1
    }, {
      "class": 'js-button-next',
      index: position + 1
    }].filter(function (obj) {
      return button.classList.contains(obj["class"]);
    }),
    _filter2 = _slicedToArray(_filter, 1),
    index = _filter2[0].index;
  if (this.stepList[index]) {
    this.slider.scrollTo(this.stepList[index].offsetLeft, 0);
  }
}
function $initSlider() {
  var _this2 = this;
  this.$observer = new IntersectionObserver($observerCallback.bind(this), {
    root: this.slider,
    rootMargin: '0px',
    threshold: .5
  });
  this.stepList.forEach(function (step) {
    _this2.$observer.observe(step);
  });
}
function $bindEvents() {
  var _this3 = this;
  // Every steps
  [this.nextStepButton, this.prevStepButton].forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      $pagination.call(_this3, button);
    });
  });

  // Open workshop button
  this.workshopOpenButton.addEventListener('click', function () {
    _this3.open();
  });

  // Close workshop button
  this.workshopCloseButton.addEventListener('click', function () {
    _this3.close();
  });
}
var Workshop = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Component} component
   */
  function Workshop(component) {
    _classCallCheck(this, Workshop);
    this.root = component.target.querySelector('.o-main');
    this.slider = component.target.querySelector('.o-slider');
    this.header = component.target.querySelector('.o-slider__header');
    this.sidebar = component.target.querySelector('.o-slider__sidebar');
    this.stepList = _toConsumableArray(component.target.querySelectorAll('.js-step'));
    this.workshopOpenButton = component.target.querySelector('.js-workshop');
    this.workshopCloseButton = component.target.querySelector('#js-close-layer-workshop');
    this.prevStepButton = component.target.querySelector('.js-button-prev');
    this.nextStepButton = component.target.querySelector('.js-button-next');
    this.pagination = component.target.querySelector('.js-pagination');
    this.$observer = null;
    if (this.workshopOpenButton) {
      $bindEvents.call(this);
      $initSlider.call(this);
    }
  }

  /**
   * @return {Boolean}
   */
  return _createClass(Workshop, [{
    key: "isOpen",
    value: function isOpen() {
      return this.root.classList.contains(activeWorkshop);
    }
  }, {
    key: "open",
    value: function open() {
      document.documentElement.classList.add(layerVisible);
      this.root.classList.add(activeWorkshop);
      this.sidebar.classList.add(activeSidebar);
      this.header.classList.add(activeHeader);
    }
  }, {
    key: "close",
    value: function close() {
      this.sidebar.classList.remove(activeSidebar);
      this.header.classList.remove(activeHeader);
      this.root.classList.remove(activeWorkshop);
      document.documentElement.classList.remove(layerVisible);
    }
  }]);
}();
export { Workshop as default };